import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import ShopThumb from './ShopThumb';
import { commissionAdapter, printAdapter, premiumContentAdapter } from './Adapters';
import { ShopThumbType } from './types';
import dasContentAdapter from './Adapters/das';
const ShopThumbFactory = (_param)=>{
    var { type  } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    let adapterType = undefined;
    if (type) {
        adapterType = type;
    } else {
        if (props.deviation.hasOwnProperty('commission')) {
            adapterType = ShopThumbType.COMMISSION;
        } else if (props.deviation.hasOwnProperty('print')) {
            adapterType = ShopThumbType.PRINT;
        } else if (props.deviation.hasOwnProperty('pcp')) {
            adapterType = ShopThumbType.PCP;
        } else if (props.deviation.hasOwnProperty('asset')) {
            adapterType = ShopThumbType.DAS;
        }
    }
    let shopThumbProps;
    switch(adapterType){
        case ShopThumbType.COMMISSION:
            shopThumbProps = commissionAdapter(props);
            break;
        case ShopThumbType.PRINT:
            shopThumbProps = printAdapter(props);
            break;
        case ShopThumbType.PCP:
            shopThumbProps = premiumContentAdapter(props);
            break;
        case ShopThumbType.DAS:
            shopThumbProps = dasContentAdapter(props);
            break;
        default:
            shopThumbProps = props;
    }
    return /*#__PURE__*/ React.createElement(ShopThumb, _extends({}, shopThumbProps));
};
export default ShopThumbFactory;
